import { Map } from 'immutable'
import { createSelector } from 'reselect'

import { getDevFlags, LDFlags } from '@lyrahealth-inc/shared-app-logic'

export const getFeatureFlagState = (state: Map<string, any>) => state?.get('featureFlag')

export const getFeatureFlags = createSelector([getFeatureFlagState], (featureFlagState) => ({
  ...(featureFlagState.get('flags').toJS() as LDFlags),
  ...getDevFlags(),
}))

export const getAdultTriageDisabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.adultTriageDisabled,
)

export const getForceAdultFlowsToHPI = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.forceAdultFlowsToHPI,
)

export const getIsCustomerDynamicSessionLimitFeatureFlagEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isCustomerDynamicSessionLimitEnabled,
)

export const getIsExpandedProgressBarEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isExpandedProgressBarEnabled,
)

export const getIsCopayForMaxCostEstimateEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isCopayForMaxCostEstimateEnabled,
)

export const getIsWellnessGoalsEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isWellnessGoalsEnabled,
)

export const getIsTrsSearchLocationDataEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isTrsSearchLocationDataEnabled,
)

export const getIsFavoritedProvidersEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isFavoritedProvidersEnabled,
)

export const getForkedTriageV2Enabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.forkedTriageV2Enabled,
)

export const getShouldShowWalmartHPICostTransparency = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.shouldShowWalmartHPICostTransparency,
)

export const getIsClientDisabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isClientDisabled,
)

export const getIsLyraForLyrians2026Enabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isLyraForLyrians2026Enabled,
)

export const getIsPromotionalSMSEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isPromotionalSMSEnabled,
)

export const getShouldHideHealthPlanPrompt = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.shouldHideHealthPlanPrompt,
)
